import { ChangeEvent, useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import InputMask from "react-input-mask";
import FormError from "./FormError";

const Input = ({ value, tooltip, onChange, loading, label, alert, placeholder, name, id, type, required, maxLength, mask, decimals, className, onBlur, onFocus }) => {

    const [length, setLength] = useState(0);

    function handleKeyDown(e) {
        let value = e.target.value;

        // Permitir teclas de borrado (Backspace, Delete, etc.)
        if (e.key === "Backspace" || e.key === "Delete") {
            return; // No hacer nada si el usuario está borrando
        }

        // Evitar escribir el punto (.) si no estamos permitiendo decimales
        if (!decimals && e.key === '.') {
            e.preventDefault(); // Prevenir la escritura del punto
            return;
        }

        // Si estamos permitiendo decimales, solo permitir un punto
        if (decimals && e.key === '.' && value.includes('.')) {
            e.preventDefault(); // Prevenir la escritura de un segundo punto
            return;
        }

        // No permitir caracteres "e", "E", "+", "-"
        if (['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault(); // Prevenir estas teclas
            return;
        }

        // Si no estamos permitiendo decimales, solo números enteros son válidos
        if (!decimals && /\D/.test(e.key)) {
            e.preventDefault(); // Prevenir caracteres no numéricos
            return;
        }
    }

    function handleInput(e) {
        let value = e.target.value;

        // Si estamos permitiendo decimales, validar que el valor no tenga más de un punto
        if (decimals && value.split('.').length > 2) {
            value = value.slice(0, value.lastIndexOf('.'));  // Eliminar el último punto adicional
        }

        // Validación de decimales (hasta dos decimales)
        if (decimals) {
            const regex = /^\d*(\.\d{0,2})?$/; // Permitir hasta dos decimales
            if (regex.test(value)) {
                onChange && onChange((e)); // Solo actualizar si es válido con decimales
            } else {
                e.target.value = value.slice(0, -1); // Eliminar el último carácter inválido
            }
        } else {
            // Solo números enteros son válidos
            const regex = /^\d*$/;
            if (regex.test(value)) {
                onChange && onChange(Number(e)); // Solo actualizar si es válido como entero
            } else {
                e.target.value = value.slice(0, -1); // Eliminar el último carácter inválido
            }
        }
    }

    return (
        <>
            {label && <label className="mb-2.5 text-black flex justify-between text-xs dark:text-white font-medium">
                <span>{label} {required && <span className="text-red-500">*</span>}</span>
                {maxLength && <span className={`${length == maxLength && "text-red"}`}>{`${length} / ${maxLength}`}</span>}
            </label>}
            {loading ? <Skeleton className="w-full rounded py-3 px-5 text-2xl" />
                :
                <InputMask
                    type={type === "number" ? "text" : type}
                    name={name}
                    mask={mask || ''}
                    id={id || undefined}
                    onFocus={(e) => onFocus && onFocus(e)}
                    onKeyDown={(e) => {
                        if (type === "number") {
                            if (maxLength) {
                                if (e.target.value.length <= Number(maxLength)) {
                                    setLength(e.target.value.length);
                                    handleKeyDown(e);
                                }
                            } else {
                                handleKeyDown(e);
                            }
                        }
                    }}
                    onChange={(e) => {
                        if (type !== "number") {
                            if (maxLength) {
                                if (e.target.value.length <= Number(maxLength)) {
                                    setLength(e.target.value.length);
                                    onChange && onChange(e);
                                }
                            } else {
                                onChange && onChange(e);
                            }
                        } else {
                            if (maxLength) {
                                if (e.target.value.length <= Number(maxLength)) {
                                    setLength(e.target.value.length);
                                    onChange && onChange(e);
                                }
                            } else {
                                onChange && onChange(e);
                            }
                        }
                    }}
                    onInput={(e) => {
                        if (type === "number") {
                            if (maxLength) {
                                if (e.target.value.length <= Number(maxLength)) {
                                    setLength(e.target.value.length);
                                    handleInput(e);
                                }
                            } else {
                                handleInput(e);
                            }
                        }
                    }}
                    onBlur={(e) => {
                        if (onBlur) onBlur(e);
                        if (type === "number" && decimals) {
                            let value = e.target.value;
                            if (value.endsWith('.')) {
                                e.target.value = value.slice(0, -1);
                                onChange && onChange(e);
                            }
                        }
                    }}
                    value={value}
                    placeholder={placeholder || ""}
                    className="w-full text-xs md:text-sm rounded-md border-stroke bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black dark:bg-[#292929] placeholder-neutral-500 dark:text-white dark:border-stone-400 transition disabled:cursor-default disabled:bg-whiter bg-white"
                />}
            {alert && <FormError errors={alert} name={name} />}
        </>
    );
};

export default Input;